export default __webpack_public_path__ + "static/media/im1.2df508f8.png";